import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import React, { Component } from 'react';
import { NumberCell } from '../../../../utils/Cells';

class IncomingBillRow extends Component {
    componentDidMount() {
        console.log(this.props)
    }

    render() {
        return (
            <TableContainer component={Paper}>
                <Table size="small" aria-label="a dense table">
                    <TableHead>
                        <TableRow>
                            <TableCell>Sorszám</TableCell>
                            <TableCell>Megnevezés</TableCell>
                            <TableCell>Számlaszám</TableCell>
                            <TableCell>Összeg</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow key="new">
                            <TableCell> {this.props.row.publicId}</TableCell>
                            <TableCell>{this.props.row.customerName}</TableCell>
                            <TableCell>{this.props.row.billNumber} </TableCell>
                            <TableCell align="right"><NumberCell value={this.props.row.amount} /></TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        )
    }
}
export default IncomingBillRow;